import React from "react";
import Reveal from "@/components/landing/Reveal";
import EditorialButton from "@/components/landing/EditorialButton";
import { STRIPE_LINKS, EVENT } from "@/lib/landingConfig";
import { useReservation } from "@/components/landing/ReservationModal";

const Closing = () => {
  const { open: openReservation } = useReservation();
  return (
    <section
      id="cierre"
      data-testid="closing-section"
      className="bg-[#63846F] text-[#FAF8F3]"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-28 md:py-36 lg:py-44">
        <Reveal>
          <p className="overline text-[#FAF8F3]/70 mb-8">
            Edición Primer Aniversario
          </p>
        </Reveal>

        <Reveal delay={100}>
          <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.02] text-[#FAF8F3]">
            No se trata solo de asistir a un evento.
            <br />
            <span className="italic">
              Se trata de ocupar el lugar desde el que quieres liderar.
            </span>
          </h2>
        </Reveal>

        <Reveal delay={200}>
          <p className="mt-12 max-w-2xl font-sans text-base md:text-lg leading-relaxed text-[#FAF8F3]/90">
            Lidera con Voz Propia es para mujeres que ya han demostrado
            capacidad, trayectoria y compromiso. Mujeres que ahora necesitan un
            espacio a la altura de sus decisiones.
          </p>
        </Reveal>

        <Reveal delay={260}>
          <p className="mt-6 max-w-2xl font-sans italic text-[#FAF8F3]/80 leading-relaxed">
            Si sientes que ha llegado el momento de liderar con más claridad,
            más influencia y una red de relaciones estratégicas reales, esta
            edición es para ti.
          </p>
        </Reveal>

        <Reveal delay={340}>
          <div className="mt-14 md:mt-16 flex flex-col sm:flex-row gap-4">
            {EVENT.generalBatchClosed ? (
              <a
                href="#info"
                className="inline-flex items-center justify-center gap-3 rounded-none border border-[#FAF8F3] bg-[#FAF8F3] text-[#3F403A] hover:bg-transparent hover:text-[#FAF8F3] transition-colors px-8 py-4 md:px-10 md:py-5 uppercase tracking-[0.22em] text-xs md:text-[13px] font-medium"
                data-testid="closing-cta-general-waitlist"
              >
                Avísame del último lote <span aria-hidden>→</span>
              </a>
            ) : (
              <EditorialButton
                as="button"
                type="button"
                onClick={() => openReservation(STRIPE_LINKS.general, "Pase General")}
                variant="onDark"
                data-testid="closing-cta-general"
              >
                Reservar Pase General
              </EditorialButton>
            )}
            {EVENT.vipSoldOut ? (
              <a
                href="#info"
                className="inline-flex items-center justify-center gap-3 rounded-none border border-[#FAF8F3]/40 bg-transparent text-[#FAF8F3]/75 hover:bg-[#FAF8F3] hover:text-[#3F403A] hover:border-[#FAF8F3] transition-colors px-8 py-4 md:px-10 md:py-5 uppercase tracking-[0.22em] text-xs md:text-[13px] font-medium"
                data-testid="closing-cta-vip-waitlist"
              >
                Lista de espera VIP <span aria-hidden>→</span>
              </a>
            ) : (
              <EditorialButton
                as="button"
                type="button"
                onClick={() => openReservation(STRIPE_LINKS.vip, "Experiencia VIP")}
                variant="onDarkOutline"
                data-testid="closing-cta-vip"
              >
                Reservar Experiencia VIP
              </EditorialButton>
            )}
          </div>
        </Reveal>

        <Reveal delay={420}>
          <div className="mt-20 md:mt-24 pt-10 border-t border-[#FAF8F3]/25">
            <p className="font-quiche text-2xl md:text-3xl text-[#FAF8F3]">
              Lidera con Voz <strong className="quiche-bold font-extrabold">Propia</strong>{" "}
              · <span className="italic font-serif">Edición Primer Aniversario</span>
            </p>
            <p className="mt-3 overline text-[#FAF8F3]/70">
              {EVENT.date} · {EVENT.city}
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Closing;
